import { render, staticRenderFns } from "./ContactView.vue?vue&type=template&id=a89a3a80&scoped=true&"
import script from "./ContactView.vue?vue&type=script&lang=js&"
export * from "./ContactView.vue?vue&type=script&lang=js&"
import style0 from "./ContactView.vue?vue&type=style&index=0&id=a89a3a80&lang=scss&scoped=true&"
import style1 from "./ContactView.vue?vue&type=style&index=1&id=a89a3a80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89a3a80",
  null
  
)

export default component.exports